import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { RelatedActivityType } from "@/shared/domain";

import { useActitivitiesQueries } from "../../useActivitiesQueries";
import ActivitiesTable from "../ActivitiesTable/ActivitiesTable";
import { StyledActivitiesContainer, StyledBtnShowMore } from "./styled";

type ActivitiesPanelProps = {
    onShowMoreClick: () => void;
    featureType: RelatedActivityType;
    policyholderId: number;
};

const ActivitiesPanel: FC<ActivitiesPanelProps> = ({ featureType, onShowMoreClick, policyholderId }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const { useActitivitiesPageQuery } = useActitivitiesQueries({
        id,
        featureType,
        policyholderId: Number(policyholderId),
    });

    const { orderBy, handleSort, result: activities } = useActitivitiesPageQuery();

    const activitiesMaxLength3 = activities.slice(0, 3);

    if (!activities.length) {
        return <></>;
    }

    return (
        <StyledActivitiesContainer>
            <ActivitiesTable
                activities={activitiesMaxLength3}
                orderBy={orderBy}
                handleSort={handleSort}
                onlySmallTable
            />
            {activities.length > 3 && (
                <StyledBtnShowMore
                    onClick={onShowMoreClick}
                    className="btnShowMore"
                    data-testid="activities_panel-button-show_more"
                >
                    {t("Common.SeeAll")}
                </StyledBtnShowMore>
            )}
        </StyledActivitiesContainer>
    );
};

export default ActivitiesPanel;
